<template>
  <ChatModal
    :name="$options.name"
    :title="title"
    @before-open="beforeOpen"
  >
    <div v-if="profile">
      <div :class="$style.tabsWrap">
        <tabs
          :tabs="tabs"
          :currentTab="currentTab"
          :class="$style.tabs"
          ref="tabs"
          @onClick="tab => currentTab = tab"
        />
        <div v-if="profile.pending" :class="$style.counter">{{ profile.pending }}</div>
      </div>
      <div v-if="currentTab === 'followers'">
        <div
          v-for="subscription in followers" :key="subscription.id"
          :class="$style.item"
          @click="showProfile(subscription.user)"
        >
          <Avatar :user="subscription.userObj" :size="44" isShowOnline :class="$style.avatar" />
          <div :class="$style.info">
            {{ subscription.userObj.displayName }}
          </div>
          <div :class="$style.actions">
            <Fab @click.native.stop="goChat"><BaseIcon name="comment-medical" /></Fab>
          </div>
        </div>
      </div>
      <div v-else-if="currentTab === 'pending'">
        <div
          v-for="subscription in pending" :key="subscription.id"
          :class="$style.item"
          @click="showProfile(subscription.user)"
        >
          <Avatar :user="subscription.userObj" :size="44" isShowOnline :class="$style.avatar" />
          <div :class="$style.info">
            {{ subscription.userObj.displayName }}
          </div>
          <div :class="$style.actions">
            <Fab><BaseIcon name="check" @click.stop="onAccept(subscription.id)" /></Fab>
            <Fab><BaseIcon name="times" @click.stop="onDecline(subscription.id)" /></Fab>
          </div>
        </div>
      </div>
    </div>
  </ChatModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ChatModal from './ChatModal'
import Tabs from 'vue-tabs-with-active-line'
import Avatar from '@/components/Avatar'
import Fab from '@/components/Fab'
import { TYPE_CODE } from '@/models/Chat'

export default {
  name: 'social-profile-subscriptions',
  components: {
    ChatModal,
    Tabs,
    Avatar,
    Fab
  },
  data () {
    return {
      profileNickname: '',
      currentTab: 'followers'
    }
  },
  computed: {
    ...mapGetters({
      getProfile: 'entities/socialProfiles/getProfile',
      getFollowers: 'entities/socialProfiles/getFollowers',
      getPending: 'entities/socialProfiles/getPending'
    }),
    profile () {
      return this.getProfile(this.profileNickname)
    },
    followers () {
      return this.getFollowers(this.profileNickname).filter(subscription => subscription.userObj)
    },
    pending () {
      return this.getPending(this.profileNickname).filter(subscription => subscription.userObj)
    },
    tabs () {
      return [
        {
          title: this.$t('socialProfile.followers'),
          value: 'followers'
        },
        {
          title: this.$t('socialProfile.pending'),
          value: 'pending'
        }
      ]
    },
    title () {
      return this.currentTab === 'followers' ? this.$t('socialProfile.followers') : this.$t('socialProfile.pending')
    }
  },
  methods: {
    beforeOpen ({ params: { profileNickname, onClose = () => {} } }) {
      this.beforeClose = onClose
      this.currentTab = 'followers'
      this.profileNickname = profileNickname
      this.fetchSubscribers(this.profileNickname)
    },
    ...mapActions({
      fetchSubscribers: 'entities/socialProfiles/fetchSubscribers',
      manageSubscription: 'entities/socialProfiles/manageSubscription',
      createChat: 'entities/chats/create'
    }),
    async goChat () {
      const { id } = await this.createChat({
        type: TYPE_CODE['one-to-one'],
        participants: [this.profile.owner]
      })
      this.$router.push({ name: 'app-chat', query: { id: window.btoa(id) } })
      this.$modal.hide(this.$options.name)
    },
    showProfile (userId) {
      this.$modal.show('profile', { userId })
    },
    onAccept (subscriptionId) {
      this.manageSubscription({ subscriptionId, type: 'accept' })
    },
    onDecline (subscriptionId) {
      this.manageSubscription({ subscriptionId, type: 'decline' })
    }
  }
}
</script>

<style module lang="scss">
.tabsWrap {
  position: relative;
}
.counter {
  position: absolute;
  border-radius: 8px;
  background-color: $text-error;
  color: $text-lightest;
  font-size: 10px;
  padding: 2px 4px;
  top: 2px;
  right: 24px;
  text-align: center;
  min-width: 16px;
  font-weight: 600;
}
.item {
  display: flex;
  padding: 15px 10px;
  cursor: pointer;
}
.avatar {
  margin-right: 8px;
  flex-shrink: 0;
}
.info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
}
.actions {
  flex-shrink: 0;
  text-align: right;
  > * {
    margin-left: 8px;
  }
}

.name {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 6px;
  width: 100%;
}
</style>
